export const Radio = {
  baseStyle: {
    control: {
      bg: 'var(--chakra-colors-background-form-default-light)',
      border: '1px solid var(--chakra-colors-border-transparent-light)',

      _dark: {
        bg: 'var(--chakra-colors-background-form-default-dark)',
        border: '1px solid var(--chakra-colors-border-transparent-dark)',

        _invalid: {
          border: '1px solid var(--chakra-colors-border-form-critical-light)',
        },
      },

      _checked: {
        bg: 'var(--chakra-colors-interactive-activate)',
        border: '1px solid var(--chakra-colors-border-transparent-light)',

        _dark: {
          border: '1px solid var(--chakra-colors-border-transparent-dark)',
          bg: 'var(--chakra-colors-interactive-activate)',
        },

        _hover: {
          bg: 'var(--chakra-colors-interactive-activate)',
        },

        _invalid: {
          border: '1px solid var(--chakra-colors-border-form-critical-light)',
        },

        _disabled: {
          bg: 'var(--chakra-colors-interactive-pressed-light)',
          border: '1px solid var(--chakra-colors-border-form-default-light)',

          _dark: {
            bg: 'var(--chakra-colors-interactive-pressed-dark)',
            border: '1px solid var(--chakra-colors-border-form-default-dark)',

            _before: {
              bg: 'var(--chakra-colors-interactive-pressed-dark)',
            },
          },

          _before: {
            bg: 'var(--chakra-colors-interactive-pressed-light)',
          },
        },

        _before: {
          bg: 'var(--chakra-colors-text-white)',

          _dark: {
            bg: 'var(--chakra-colors-text-white)',
          },
        },
      },

      _invalid: {
        border: '1px solid var(--chakra-colors-border-form-critical-light)',
      },

      _disabled: {
        bg: 'var(--chakra-colors-background-form-disabled-light)',
        border: '1px solid var(--chakra-colors-border-form-default-light)',

        _dark: {
          bg: 'var(--chakra-colors-background-form-disabled-dark)',
          border: '1px solid var(--chakra-colors-border-form-default-dark)',
        },
      },
    },
  },

  sizes: {
    sm: {
      control: {
        width: '0.875rem',
        height: '0.875rem',
        _checked: {
          _before: {
            w: '0.25rem',
            h: '0.25rem',
          },
        },
      },
    },
    md: {
      control: {
        width: '1rem',
        height: '1rem',
        _checked: {
          _before: {
            w: '0.375rem',
            h: '0.375rem',
          },
        },
      },
    },
    lg: {
      control: {
        width: '1.25rem',
        height: '1.25rem',
        _checked: {
          _before: {
            w: '0.5rem',
            h: '0.5rem',
          },
        },
      },
    },
  },
}

/** 
  Example of usage:

@prop {string} aria-describedby
@prop {boolean} defaultChecked
@prop {boolean} defaultIsChecked
@prop {string} id
@prop {boolean} isChecked
@prop {boolean} isDisabled
@prop {boolean} isFocusable
@prop {boolean} isFullWidth
@prop {boolean} isInvalid
@prop {boolean} isReadOnly
@prop {boolean} isRequired
@prop {string} name
@prop {string} onChange
@prop {string} size = 'sm' | 'md' | 'lg'
@prop {string} spacing
@prop {string | number} value

@example <Radio isChecked={true} isDisabled={true} size='md' />
*/
